import React, { useEffect, useState } from 'react';
import './Culture.css'; // Your CSS file for styling
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import { db, storage } from '../../utils/firebase'; // Firebase config
import { collection, getDocs, query, where } from 'firebase/firestore';
import { ref, getDownloadURL } from 'firebase/storage';
import TripInspiration from '../carousel/TripInspiration';

const Festival = () => {
  const [data, setData] = useState(null);
  const [images, setImages] = useState([]);

  const mainTitle = 'Festival'; // Replace with the specific main title you want to filter by

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch data from Firestore
        const collectionRef = collection(db, 'explore_about_bacoor');
        const q = query(collectionRef, where('main_title', '==', mainTitle));
        const querySnapshot = await getDocs(q);

        const fetchedData = [];
        querySnapshot.forEach((doc) => {
          fetchedData.push({ id: doc.id, ...doc.data() });
        });

        if (fetchedData.length > 0) {
          setData(fetchedData[0]);

          // Fetch images from Storage
          const imageUrls = await Promise.all(
            ['1', '2', '3'].map(async (num) => {
              const fileName = `${num}${fetchedData[0].id}.jpg`; // Format: 1{entity.Id}.jpg, 2{entity.Id}.jpg, etc.
              const imageRef = ref(storage, `exploreabout/${fileName}`);
              return getDownloadURL(imageRef);
            })
          );

          setImages(imageUrls);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [mainTitle]);

  return (
    <div>
      <Navbar />
      <div className="culture-container">
        {data ? (
          <>
            <h1 className="main-title142">{data.main_title}</h1>
            <div className="section">
              <div className="image-container">
                <img src={images[0]} alt="Image 1" />
              </div>
              <div className="text-container">
                <h2>{data.title_1}</h2>
                <p>{data.description_1}</p>
                <p>{data.description_2}</p>
              </div>
            </div>
            <div className="section">
              
              <div className="text-container">
                <h2>{data.title_2}</h2>
                <p>{data.description_3}</p>
                <p>{data.description_4}</p>
              </div>
              <div className="image-container">
                <img src={images[1]} alt="Image 2" />
              </div>
            </div>
            <div className="section">
              <div className="image-container">
                <img src={images[2]} alt="Image 3" />
              </div>
              <div className="text-container">
                <h2>{data.title_3}</h2>
                <p>{data.description_5}</p>
                <p>{data.description_6}</p>
              </div>
            </div>
          </>
        ) : (
          <p>Loading data...</p>
        )}
      </div>
      <TripInspiration/>
      <Footer />
    </div>
  );
};

export default Festival;
